import Breadcrumbs from '../common/Breadcrumbs';
import { RATING_FILTER_OPTIONS, SORT_OPTIONS } from './courseListConstants';

const STAR_PATH =
  'M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z';

function SortIcon() {
  return (
    <svg className="h-[13px] w-[17px] shrink-0" viewBox="0 0 17 13" fill="currentColor" aria-hidden>
      <path d="M4.5 1.25L7 4.25H5.55V11.75H3.45V4.25H2L4.5 1.25Z" />
      <path d="M12.5 11.75L10 8.75H11.45V1.25H13.55V8.75H15L12.5 11.75Z" />
    </svg>
  );
}

function FilterIcon() {
  return (
    <svg className="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
      />
    </svg>
  );
}

function DrawerCloseIcon() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function SectionTitle({ icon, label }) {
  return (
    <div className="flex items-center gap-2 text-base font-semibold text-[#1B1B1B]">
      <span className="text-lg" aria-hidden>
        {icon}
      </span>
      <span>{label}</span>
    </div>
  );
}

function CheckboxRow({ checked, label, onChange }) {
  return (
    <label className="flex cursor-pointer items-center gap-2 text-sm text-[#1B1B1B]">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 rounded border-gray-300 text-[#9369CC] focus:ring-[#9369CC]"
      />
      <span>{label}</span>
    </label>
  );
}

function RadioRow({ checked, label, onChange, children }) {
  return (
    <label className="flex cursor-pointer items-center gap-3 text-sm text-[#1B1B1B]">
      <input
        type="radio"
        checked={checked}
        onChange={() => onChange()}
        className="h-4 w-4 shrink-0 border-gray-300 text-[#9369CC] focus:ring-[#9369CC]"
      />
      {children || <span>{label}</span>}
    </label>
  );
}

function FilterStar() {
  return (
    <svg className="h-[18px] w-[18px] text-[#F5A623] drop-shadow-sm" fill="currentColor" viewBox="0 0 20 20" aria-hidden>
      <path d={STAR_PATH} />
    </svg>
  );
}

function FilterStarRow({ count }) {
  return (
    <div className="flex items-center gap-1.5" aria-label={`${count} star rating`}>
      {Array.from({ length: count }, (_, index) => (
        <FilterStar key={index} />
      ))}
    </div>
  );
}

function RatingSectionTitle() {
  return (
    <div className="flex items-center gap-2 text-base font-semibold text-[#1B1B1B]">
      <span className="relative inline-flex h-7 w-7 shrink-0" aria-hidden>
        <svg className="h-7 w-7 text-[#F5A623]" fill="currentColor" viewBox="0 0 20 20">
          <path d={STAR_PATH} />
        </svg>
        <svg
          className="absolute -bottom-0.5 -right-0.5 h-3.5 w-3.5 text-[#9B9B9B]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </span>
      <span>Rating</span>
    </div>
  );
}

export function CourseSortFilterToolbar({
  breadcrumbItems,
  sort,
  setSort,
  showSort,
  setShowSort,
  openFilters,
  setShowFilters,
}) {
  return (
    <section className="bg-gradient-to-b from-[#ECE8F8] via-[#F3EFFC] to-white">
      <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <Breadcrumbs variant="page" items={breadcrumbItems} />

          <div className="relative flex items-center gap-3">
            <div className="relative">
              <button
                type="button"
                onClick={() => {
                  setShowSort((open) => !open);
                  setShowFilters(false);
                }}
                className="inline-flex items-center gap-3 rounded-[10px] bg-[#9B9B9B] px-7 py-2 text-base font-semibold text-white shadow-sm transition hover:bg-[#8D8D8D]"
              >
                Sort By
                <SortIcon />
              </button>

              {showSort && (
                <div className="absolute right-0 top-full z-20 mt-2 w-48 rounded-sm border border-gray-200 bg-white p-2 shadow-lg">
                  {SORT_OPTIONS.map((option) => (
                    <button
                      key={option.value}
                      type="button"
                      onClick={() => {
                        setSort(option.value);
                        setShowSort(false);
                      }}
                      className={`block w-full rounded-lg px-3 py-2 text-left text-sm font-medium transition ${
                        sort === option.value
                          ? 'bg-[#9369CC]/10 text-[#9369CC]'
                          : 'text-[#1B1B1B] hover:bg-gray-50'
                      }`}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <button
              type="button"
              onClick={openFilters}
              className="inline-flex items-center gap-3 rounded-xl bg-[#9369CC] px-8 py-2 text-base font-semibold text-white shadow-sm transition hover:bg-[#7d56b8]"
            >
              Filter
              <FilterIcon />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CourseFiltersDrawer({
  showFilters,
  setShowFilters,
  filteredCount,
  filterOptions,
  draftFilters,
  setDraftFilters,
  toggleDraftList,
  setDraftClass,
  applyFilters,
  clearFilters,
}) {
  if (!showFilters) return null;

  const selectedClassId = String(draftFilters.classes?.[0] || '');
  const visibleSubjects = filterOptions.subjects.filter(
    (item) => !selectedClassId || item.classIds?.includes(selectedClassId)
  );

  return (
    <div className="fixed inset-0 z-50">
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        aria-label="Close filters"
        onClick={() => setShowFilters(false)}
      />

      <aside className="absolute right-0 top-0 flex h-full w-[340px] max-w-[90vw] flex-col bg-white shadow-2xl">
        <div className="relative bg-gradient-to-r from-[#3A2A57] to-[#9369CC] px-5 pb-4 pt-5 text-center text-white">
          <button
            type="button"
            onClick={() => setShowFilters(false)}
            className="absolute left-3 top-3 rounded-md p-2 text-white/90 hover:bg-white/10"
            aria-label="Close"
          >
            <DrawerCloseIcon />
          </button>
          <div className="text-xl font-semibold">Apply Filters</div>
          <div className="mt-1 text-xs text-white/80">{filteredCount} Course Found</div>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-5">
          <div className="space-y-5">
            <div>
              <SectionTitle icon="🎓" label="Class" />
              <div className="mt-3 space-y-2">
                {filterOptions.classes.map((item) => (
                  <RadioRow
                    key={item.id}
                    label={item.label}
                    checked={selectedClassId === String(item.id)}
                    onChange={() => setDraftClass(item.id)}
                  />
                ))}
              </div>
            </div>

            <hr className="border-t border-gray-200" />

            <div>
              <SectionTitle icon="📚" label="Subject" />
              <div className="mt-3 space-y-2">
                {visibleSubjects.map((item) => (
                  <CheckboxRow
                    key={item.id}
                    label={item.label}
                    checked={(draftFilters.subjects || []).map(String).includes(String(item.id))}
                    onChange={(checked) => toggleDraftList('subjects', item.id, checked)}
                  />
                ))}
                {!visibleSubjects.length ? (
                  <p className="text-sm text-[#666666]">No subjects available for the selected class.</p>
                ) : null}
              </div>
            </div>

            <hr className="border-t border-gray-200" />

            <div>
              <SectionTitle icon="👤" label="Instructor" />
              <div className="mt-3 space-y-2">
                {filterOptions.instructors.map((item) => (
                  <CheckboxRow
                    key={item.id}
                    label={item.label}
                    checked={(draftFilters.instructors || []).map(String).includes(String(item.id))}
                    onChange={(checked) => toggleDraftList('instructors', item.id, checked)}
                  />
                ))}
              </div>
            </div>

            <hr className="border-t border-gray-200" />

            <div>
              <RatingSectionTitle />
              <div className="mt-3 space-y-3">
                {RATING_FILTER_OPTIONS.map((stars) => (
                  <RadioRow
                    key={stars}
                    checked={String(draftFilters.rating || '') === String(stars)}
                    onChange={() => setDraftFilters((prev) => ({ ...prev, rating: String(stars) }))}
                  >
                    <FilterStarRow count={stars} />
                  </RadioRow>
                ))}
                <RadioRow
                  checked={String(draftFilters.rating || '') === ''}
                  onChange={() => setDraftFilters((prev) => ({ ...prev, rating: '' }))}
                  label="All"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between gap-3 border-t border-gray-200 px-5 py-4">
          <button
            type="button"
            onClick={clearFilters}
            className="w-full rounded-full border border-[#9369CC] bg-white px-4 py-2.5 text-sm font-semibold text-[#9369CC]"
          >
            Reset
          </button>
          <button
            type="button"
            onClick={applyFilters}
            className="w-full rounded-full bg-gradient-to-r from-[#6A74E1] to-[#B539FD] px-4 py-2.5 text-sm font-semibold text-white"
          >
            Apply
          </button>
        </div>
      </aside>
    </div>
  );
}
